import i18n from '@/i18n'
import { mapActions } from 'vuex'
import { SnackbarStyle, ColvenTheme, REGEX, DEFAULT_SPEED_VALUE } from '@/constants/constants'
import { dialogTypes } from '@/constants/dialogTypes'
import EnterpriseDataTabComponent from '@/components/enterprise/dialog/tabs/data/EnterpriseDataTabComponent.vue'
import EnterpriseAddressTabComponent from '@/components/enterprise/dialog/tabs/address/EnterpriseAddressTabComponent.vue'
import EnterpriseHeaderTabComponent from '@/components/enterprise/dialog/tabs/header/EnterpriseHeaderTabComponent.vue'
import EnterpriseLoginLogoTabComponent from '@/components/enterprise/dialog/tabs/login-logo/EnterpriseLoginLogoTabComponent.vue'
import EnterpriseThemeTabComponent from '@/components/enterprise/dialog/tabs/theme/EnterpriseThemeTabComponent.vue'
import EnterpriseCommentsTabComponent from '@/components/enterprise/dialog/tabs/comments/EnterpriseCommentsTabComponent.vue'
import EnterpriseEventsTabComponent from '@/components/enterprise/dialog/tabs/events/EnterpriseEventsTabComponent.vue'
import EnterpriseRusesTabComponent from '@/components/enterprise/dialog/tabs/ruses/EnterpriseRusesTabComponent.vue'
import EnterpriseScoringTabComponent from '@/components/enterprise/dialog/tabs/scoring/EnterpriseScoringTabComponent.vue'
// import EnterpriseUsersTabComponent from '@/components/enterprise/dialog/tabs/users/EnterpriseUsersTabComponent.vue'
import EnterpriseSectorsTabComponent from '@/components/enterprise/dialog/tabs/sectors/EnterpriseSectorsTabComponent.vue'
import EnterpriseHarvestTabComponent from '@/components/enterprise/dialog/tabs/harvest/EnterpriseHarvestTabComponent.vue'
import { enterpriseService } from '@/services/enterprise.service'
import { scoringService } from '@/services/scoring.service'
import { authService } from '@/services/auth.service'
import { Util, SCORING_SYSTEM } from '@colven/common-domain-lib/lib'
import { clone } from 'ramda'
import equal from 'fast-deep-equal'
import Vue from 'vue'
import moment from 'moment'
import { cnpjValidator } from '@/tools/functions'

export default {
    name: 'EnterpriseDialogComponent',
    components: {
        EnterpriseDataTabComponent,
        EnterpriseAddressTabComponent,
        EnterpriseHeaderTabComponent,
        EnterpriseLoginLogoTabComponent,
        EnterpriseThemeTabComponent,
        EnterpriseScoringTabComponent,
        EnterpriseCommentsTabComponent,
        EnterpriseEventsTabComponent,
        EnterpriseRusesTabComponent,
        // EnterpriseUsersTabComponent,
        EnterpriseSectorsTabComponent,
        EnterpriseHarvestTabComponent
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        }
    },
    beforeMount() {
        this.items.push(this.enterpriseDialogDataTab);
        // this.items.push(this.enterpriseDialogUsersTab);
        this.items.push(this.enterpriseDialogAddressTab);
        this.items.push(this.enterpriseDialogHeaderTab);
        this.items.push(this.enterpriseDialogLoginTab);
        this.items.push(this.enterpriseDialogThemeTab);
        this.items.push(this.enterpriseDialogCommentsTab);
        this.items.push(this.enterpriseDialogEventsTab);
        this.items.push(this.enterpriseDialogRusesTab);
        this.items.push(this.enterpriseDialogSectorsTab);
        this.items.push(this.enterpriseDialogScoringTab);
        this.items.push(this.enterpriseDialogHarvestTab)
    },
    data: () => ({
        // tab seleccionada
        tab: null,
        // modelos de los tabs
        enterpriseDialogDataTab: {
            key: 'enterpriseDialogDataTab',
            tab: i18n.t('enterprise.editDialog.tabs.data'),
            tooltip: i18n.t('enterprise.editDialog.tabs.dataTooltip'),
            icon: 'mdi-form-textbox',
            content: {
                _uid: 'h8HeWcUrqk',
                component: 'EnterpriseDataTabComponent',
                headline: 'EnterpriseDataTabComponent'
            },
            model: {
                name: null,
                phone: null,
                cuit: null,
                email: null,
                fax: null,
                suspended: false,
                customTimeSpan: {
                    name: null,
                    start: null,
                    enable: null,
                    shift: null
                }
            },
            validForm: false
        },
        enterpriseDialogAddressTab: {
            key: "enterpriseDialogAddressTab",
            tab: i18n.t("enterprise.editDialog.tabs.address"),
            tooltip: i18n.t("enterprise.editDialog.tabs.addressTooltip"),
            icon: "mdi-map-marker",
            content: {
                _uid: "DuhiNBVL18",
                component: "EnterpriseAddressTabComponent",
                headline: "EnterpriseAddressTabComponent"
            },
            model: {
                address: null,
                cityId: null,
                district: null,
                provinceId: null,
                countryId: null,
                timezone: -3.0,
                timezoneId: 56
            },
            validForm: false
        },
        enterpriseDialogHeaderTab: {
            key: "enterpriseDialogHeaderTab",
            tab: i18n.t("enterprise.editDialog.tabs.header"),
            tooltip: i18n.t("enterprise.editDialog.tabs.headerTooltip"),
            icon: "mdi-page-layout-header",
            content: {
                _uid: "eYLQamULAg",
                component: "EnterpriseHeaderTabComponent",
                headline: "EnterpriseHeaderTabComponent"
            },
            model: {
                logo: null,
                menu: [],
                locales: {
                    es: {},
                    en: {},
                    pt: {}
                }
            },
            validForm: false
        },
        enterpriseDialogLoginTab: {
            key: "enterpriseDialogLoginTab",
            tab: i18n.t("enterprise.editDialog.tabs.login"),
            tooltip: i18n.t("enterprise.editDialog.tabs.loginTooltip"),
            icon: "mdi-login-variant",
            content: {
                _uid: "i8Fqrv7J5L",
                component: "EnterpriseLoginLogoTabComponent",
                headline: "EnterpriseLoginLogoTabComponent"
            },
            model: {
                loginLogo: null,
                loginBackgroundImage: null
            },
            validForm: false
        },
        enterpriseDialogThemeTab: {
            key: "enterpriseDialogThemeTab",
            tab: i18n.t("enterprise.editDialog.tabs.themes"),
            tooltip: i18n.t("enterprise.editDialog.tabs.themesTooltip"),
            icon: "mdi-palette",
            content: {
                _uid: "8sxMIMBzKx",
                component: "EnterpriseThemeTabComponent",
                headline: "EnterpriseThemeTabComponent"
            },
            model: {
                themes: clone(ColvenTheme)
            },
            validForm: false
        },
        enterpriseDialogCommentsTab: {
            key: "enterpriseDialogCommentsTab",
            tab: i18n.t("enterprise.editDialog.tabs.comments"),
            tooltip: i18n.t("enterprise.editDialog.tabs.commentsTooltip"),
            icon: "mdi-form-textarea",
            content: {
                _uid: "h8HeWcUrqh",
                component: "EnterpriseCommentsTabComponent",
                headline: "EnterpriseCommentsTabComponent"
            },
            model: {
                additionalInformation1: null,
                additionalInformation2: null
            },
            validForm: false
        },
        enterpriseDialogEventsTab: {
            key: "enterpriseDialogEventsTab",
            tab: i18n.t("enterprise.editDialog.tabs.events"),
            tooltip: i18n.t("enterprise.editDialog.tabs.eventsTooltip"),
            icon: "mdi-state-machine",
            content: {
                _uid: "WC9enPMcAB",
                component: "EnterpriseEventsTabComponent",
                headline: "EnterpriseEventsTabComponent"
            },
            model: {
                events: {},
                enterpriseId: null,
            },
            validForm: false
        },
        enterpriseDialogRusesTab: {
            key: "enterpriseDialogRusesTab",
            tab: i18n.t("enterprise.editDialog.tabs.ruses"),
            tooltip: i18n.t("enterprise.editDialog.tabs.rusesTooltip"),
            icon: "mdi-file-cog-outline",
            content: {
                _uid: "WC9enPMcAC",
                component: "EnterpriseRusesTabComponent",
                headline: "EnterpriseRusesTabComponent"
            },
            model: {
                ruses: {}
            }
        },
        enterpriseDialogSectorsTab: {
            key: "enterpriseDialogSectorsTab",
            tab: i18n.t("enterprise.editDialog.tabs.sectors"),
            tooltip: i18n.t("enterprise.editDialog.tabs.sectorsTooltip"),
            icon: "mdi-graph",
            content: {
                _uid: "WC9enPMcAD",
                component: "EnterpriseSectorsTabComponent",
                headline: "EnterpriseSectorsTabComponent"
            },
            model: {
                sectors: []
            },
            validForm: false
        },
        enterpriseDialogScoringTab: {
            key: "enterpriseDialogScoringTab",
            tab: i18n.t("enterprise.editDialog.tabs.scoring"),
            tooltip: i18n.t("enterprise.editDialog.tabs.scoringTooltip"),
            icon: "mdi-speedometer",
            content: {
                _uid: "WC9enPMcAE",
                component: "EnterpriseScoringTabComponent",
                headline: "EnterpriseScoringTabComponent"
            },
            model: {
                scoringSystem: SCORING_SYSTEM.ADDITION,
                additionMaxValue: null,
                substractionInitialValue: null,
                maxSpeedHeavy: null,
                withScoring: false,
                firstLevel: [],
                secondLevel: {
                    timeWindow: null,
                    hardBraking: {
                        sligth: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        medium: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        serious: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        }
                    },
                    acceleration: {
                        sligth: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        medium: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        serious: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        }
                    },
                    corneringAcceleration: {
                        sligth: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        medium: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        serious: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        }
                    },
                    disconnection: {
                        sligth: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        medium: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        serious: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        }
                    }
                },
                thirdLevel: {
                    maxStopTime: null,
                    nightSchedule: {
                        start: null,
                        end: null
                    },
                    ralenti: {
                        sligth: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        medium: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        serious: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        }
                    },
                    continuousDriving: {
                        sligth: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        medium: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        serious: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        }
                    },
                    nightDriving: {
                        sligth: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        medium: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        serious: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        }
                    },
                    incompleteRest: {
                        sligth: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        medium: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        serious: {
                            range: {
                                min: 0,
                                max: null
                            },
                            weightedValue: null
                        }
                    }
                }
            },
            validForm: false
        },
        enterpriseDialogHarvestTab: {
            key: "enterpriseDialogHarvestTab",
            tab: i18n.t("enterprise.editDialog.tabs.harvest"),
            tooltip: i18n.t("enterprise.editDialog.tabs.harvestTooltip"),
            icon: "mdi-grass",
            content: {
                _uid: "WCDg34CaD",
                component: "EnterpriseHarvestTabComponent",
                headline: "EnterpriseHarvestTabComponent"
            },
            model: {
                harvestStartTime: {
                    start: null,
                    harvests: []
                },
                enterpriseTimezone: null
            },
            validForm: false
        },
        // enterpriseDialogUsersTab: {
        //     key: "enterpriseDialogUsersTab",
        //     tab: i18n.t("enterprise.editDialog.tabs.users"),
        //     tooltip: i18n.t("enterprise.editDialog.tabs.usersTooltip"),
        //     icon: "mdi-account-multiple-outline",
        //     content: {
        //         _uid: "13d82b385c",
        //         component: "EnterpriseUsersTabComponent",
        //         headline: "EnterpriseUsersTabComponent"
        //     },
        //     model: {
        //         enterpriseId: null,
        //         usersSelected: [],
        //         fullUserList: []
        //     },
        //     validForm: false
        // },
        items: [],
        // reglas de validación
        validationRules: {
            required: (value) => !!value || value === 0 || `${i18n.t('required')}`,
            email: (value) => !value || REGEX.email.test(value) || `${i18n.t('error.invalidEmail')}`,
            phone: (value) => !value || REGEX.phone.test(value) || `${i18n.t('error.invalidPhone')}`,
            cuit: (value) => !value || Util.validateCuit(value.toString()) || `${i18n.t('error.invalidCUIT')}`,
            cnpj: (value) => !value || cnpjValidator(value.toString()) || `${i18n.t('error.invalidCNPJ')}`,
            logo: [(value) => !value || value.size < 2000000 || `${i18n.t('error.imageSize')}`,
            (value) => !value || REGEX.imageType.test(value.name) || `${i18n.t('error.imageType')}`],
            requiredWithCheck: (check, value) => !check || !!value || `${i18n.t('required')}`,
            min: (value, minValue) => !value || value >= minValue || `${i18n.t('min', { min: minValue })}`,
            noDuplicateEvent: (allValues, value) => !(allValues.filter(v => v === value).length > 1) || `${i18n.t('error.duplicateEvent')}`,
            validateInteger: (value) => !!Number.isInteger(value) || `${i18n.t('integer')}`
        },
        // flag para resetear validaciones en los formularios
        resetForms: false,
        // para validar luego si se realizaron cambios en la configuración de scoring
        scoringConfigurationBackUp: null,
        disableSaveBtnFlag: false
    }),
    computed: {
        /**
         * Validación de completitud de los niveles 2 y 3 de la condiguración de scoring
         */
        scoringConfigurationLevelsValidation() {
            const secondLevelInfractions = ['hardBraking', 'acceleration', 'corneringAcceleration', 'disconnection']
            const thirdLevelInfractions = ['ralenti', 'continuousDriving', 'nightDriving', 'incompleteRest']
            const ranges = ['sligth', 'medium', 'serious']

            let secondLevelValidation = true
                && this.enterpriseDialogScoringTab.model.secondLevel.timeWindow != null
            let i = 0
            while (i < secondLevelInfractions.length && secondLevelValidation) {
                let r = 0
                while (r < ranges.length && secondLevelValidation) {
                    secondLevelValidation = secondLevelValidation
                        && this.enterpriseDialogScoringTab.model.secondLevel[secondLevelInfractions[i]][ranges[r]].range.min != null
                        && ((this.enterpriseDialogScoringTab.model.secondLevel[secondLevelInfractions[i]][ranges[r]].range.max != null) || (ranges[r] === 'serious' && (this.enterpriseDialogScoringTab.model.secondLevel[secondLevelInfractions[i]][ranges[r]].range.max == null)))
                        && this.enterpriseDialogScoringTab.model.secondLevel[secondLevelInfractions[i]][ranges[r]].weightedValue != null
                    r++
                }
                i++
            }

            let thirdLevelValidation = true
                && this.enterpriseDialogScoringTab.model.thirdLevel.maxStopTime != null
                && this.enterpriseDialogScoringTab.model.thirdLevel.nightSchedule.start != null
                && this.enterpriseDialogScoringTab.model.thirdLevel.nightSchedule.end != null
            let j = 0
            while (j < thirdLevelInfractions.length && thirdLevelValidation) {
                let r = 0
                while (r < ranges.length && thirdLevelValidation) {
                    if (thirdLevelInfractions[j] !== 'incompleteRest') {
                        thirdLevelValidation = thirdLevelValidation
                            && this.enterpriseDialogScoringTab.model.thirdLevel[thirdLevelInfractions[j]][ranges[r]].range.min != null
                            && ((this.enterpriseDialogScoringTab.model.thirdLevel[thirdLevelInfractions[j]][ranges[r]].range.max != null) || (ranges[r] === 'serious' && (this.enterpriseDialogScoringTab.model.thirdLevel[thirdLevelInfractions[j]][ranges[r]].range.max == null)))
                            && this.enterpriseDialogScoringTab.model.thirdLevel[thirdLevelInfractions[j]][ranges[r]].weightedValue != null
                    } else {
                        thirdLevelValidation = thirdLevelValidation
                            && this.enterpriseDialogScoringTab.model.thirdLevel[thirdLevelInfractions[j]][ranges[r]].range.min != null
                            && this.enterpriseDialogScoringTab.model.thirdLevel[thirdLevelInfractions[j]][ranges[r]].range.max != null
                            && this.enterpriseDialogScoringTab.model.thirdLevel[thirdLevelInfractions[j]][ranges[r]].weightedValue != null
                    }
                    r++
                }
                j++
            }

            return secondLevelValidation && thirdLevelValidation
        },
        eventConfigurationValidation() {
            let valid = true
            Object.values(this.enterpriseDialogEventsTab.model.events).forEach(events => {
                events.forEach(event => {
                    if (!event.eventNumber || !event.eventType) {
                        valid = false
                        return
                    }
                })
                if (!valid) return
                let seen = new Set()
                const duplicate = (events.some(e => seen.size === seen.add(e.eventNumber).size))
                if (duplicate) {
                    valid = false
                    return
                }
            })
            return valid;
        },
        /**
         * Retorna un boolean para habilitar / deshabilitar el botón guardar del dialog
         *
         * PAGRO-1677 -> Se quitó el requerido de la config de scoring. Sólo se valida si el formulario se ha "tocado", algún valor se modificó
         */
        disableSaveBtn() {
            // Chequeo si existe una configuracion de scoring
            this.enterpriseDialogScoringTab.model.withScoring = !!this.scoringConfigurationLevelsValidation;
            return !this.enterpriseDialogDataTab.validForm || !this.enterpriseDialogAddressTab.validForm
                || !this.enterpriseDialogHeaderTab.validForm || !this.enterpriseDialogLoginTab.validForm
                || !this.enterpriseDialogThemeTab.validForm || !this.enterpriseDialogCommentsTab.validForm
                || (!equal(this.enterpriseDialogScoringTab.model, this.scoringConfigurationBackUp) && !this.enterpriseDialogScoringTab.validForm && this.enterpriseDialogScoringTab.model.withScoring)
                || (!equal(this.enterpriseDialogScoringTab.model, this.scoringConfigurationBackUp) && !this.scoringConfigurationLevelsValidation && this.enterpriseDialogScoringTab.model.withScoring)
                || !this.eventConfigurationValidation || !this.enterpriseDialogSectorsTab.validForm || this.disableSaveBtnFlag
        },
        /**
         * Para mostrar el warning de que el tab de la configuración de scoring fue modificado
         */
        showScoringconfigurationWarning() {
            return this.disableSaveBtn && ((!equal(this.enterpriseDialogScoringTab.model, this.scoringConfigurationBackUp) && !this.enterpriseDialogScoringTab.validForm && this.enterpriseDialogScoringTab.model.withScoring)
                || (!equal(this.enterpriseDialogScoringTab.model, this.scoringConfigurationBackUp) && !this.scoringConfigurationLevelsValidation && this.enterpriseDialogScoringTab.model.withScoring))
        }
    },
    created() {
    },
    mounted() {
    },
    methods: {
        /**
         * actions del breadcrumbs
         */
        ...mapActions('breadcrumbs', [
            'pushBread',
            'pullBread'
        ]),
        /**
         * actions del snackbar
         */
        ...mapActions('snackbar', [
            'showSnackbar',
            'closeSnackbar'
        ]),
        /**
         * Resetea los campos del formulario de creación/actualización
         */
        resetFields() {
            this.enterpriseDialogDataTab.model.name = null
            this.enterpriseDialogDataTab.model.phone = null
            this.enterpriseDialogDataTab.model.cuit = null
            this.enterpriseDialogDataTab.model.email = null
            this.enterpriseDialogDataTab.model.fax = null
            this.enterpriseDialogDataTab.model.suspended = false
            this.enterpriseDialogDataTab.model.customTimeSpan = {
                name: null,
                start: null
            }

            this.enterpriseDialogAddressTab.model.address = null
            this.enterpriseDialogAddressTab.model.cityId = null
            this.enterpriseDialogAddressTab.model.district = null
            this.enterpriseDialogAddressTab.model.provinceId = null
            this.enterpriseDialogAddressTab.model.countryId = null
            this.enterpriseDialogAddressTab.model.timezone = null
            this.enterpriseDialogAddressTab.model.timezoneId = null

            this.enterpriseDialogHeaderTab.model.logo = null
            this.enterpriseDialogHeaderTab.menu = []
            this.enterpriseDialogHeaderTab.locales = {
                es: {},
                en: {},
                pt: {}
            }

            this.enterpriseDialogLoginTab.model.loginLogo = null
            this.enterpriseDialogLoginTab.model.loginBackgroundImage = null

            this.enterpriseDialogThemeTab.model.themes = clone(ColvenTheme)

            this.enterpriseDialogCommentsTab.model.additionalInformation1 = null
            this.enterpriseDialogCommentsTab.model.additionalInformation2 = null

            this.enterpriseDialogScoringTab.model.scoringSystem = SCORING_SYSTEM.ADDITION
            this.enterpriseDialogScoringTab.model.additionMaxValue = null
            this.enterpriseDialogScoringTab.model.substractionInitialValue = null
            this.enterpriseDialogScoringTab.model.maxSpeedHeavy = null
            this.enterpriseDialogScoringTab.model.firstLevel = []
            this.enterpriseDialogScoringTab.model.secondLevel = {
                timeWindow: null,
                hardBraking: {
                    sligth: {
                        range: {
                            min: null,
                            max: null
                        },
                        weightedValue: null
                    },
                    medium: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    },
                    serious: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    }
                },
                acceleration: {
                    sligth: {
                        range: {
                            min: null,
                            max: null
                        },
                        weightedValue: null
                    },
                    medium: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    },
                    serious: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    }
                },
                corneringAcceleration: {
                    sligth: {
                        range: {
                            min: null,
                            max: null
                        },
                        weightedValue: null
                    },
                    medium: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    },
                    serious: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    }
                },
                disconnection: {
                    sligth: {
                        range: {
                            min: null,
                            max: null
                        },
                        weightedValue: null
                    },
                    medium: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    },
                    serious: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    }
                }
            }
            this.enterpriseDialogScoringTab.model.thirdLevel = {
                maxStopTime: null,
                nightSchedule: {
                    start: null,
                    end: null
                },
                ralenti: {
                    sligth: {
                        range: {
                            min: null,
                            max: null
                        },
                        weightedValue: null
                    },
                    medium: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    },
                    serious: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    }
                },
                continuousDriving: {
                    sligth: {
                        range: {
                            min: null,
                            max: null
                        },
                        weightedValue: null
                    },
                    medium: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    },
                    serious: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    }
                },
                nightDriving: {
                    sligth: {
                        range: {
                            min: null,
                            max: null
                        },
                        weightedValue: null
                    },
                    medium: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    },
                    serious: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    }
                },
                incompleteRest: {
                    sligth: {
                        range: {
                            min: null,
                            max: null
                        },
                        weightedValue: null
                    },
                    medium: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    },
                    serious: {
                        range: {
                            min: 0,
                            max: null,
                        },
                        weightedValue: null
                    }
                }
            }

            this.enterpriseDialogEventsTab.model.events = {}
            this.enterpriseDialogEventsTab.model.enterpriseId = null

            this.enterpriseDialogRusesTab.model.ruses = {}
            // this.enterpriseDialogUsersTab.model.enterpriseId = null

            this.enterpriseDialogSectorsTab.model.sectors = []

            this.enterpriseDialogHarvestTab.model.harvestStartTime.start = null
            this.enterpriseDialogHarvestTab.model.harvestStartTime.harvests = []

            // para limpiar las validaciones en los formularios
            this.resetForms = true
            const that = this
            Vue.nextTick(function () {
                that.resetForms = false
            })
        },
        /**
         * Click fuera del dialog
         */
        clickOutside() {
            this.cancel()
        },
        /**
         * Botón cancelar del diálogo
         */
        cancel() {
            this.pullBread(dialogTypes.ENTERPRISE.key)
            this.resetFields()
        },
        
        /**
         * Botón guardar del diálogo
         */
        async save() {
            this.disableSaveBtnFlag = true;

            if (this.model.update) {
                // update
                const enterpriseDto = this.getEnterpriseDto()
                // remover imagen del dto
                enterpriseDto.loginBackgroundImage = null
                await enterpriseService.update(enterpriseDto).then(() => {
                    // cuando retorne la promesa, realizar update de unicamente las imágenes
                    enterpriseDto.loginBackgroundImage = this.setBackgroundImage()
                    enterpriseService.saveImage(enterpriseDto.name, enterpriseDto.loginBackgroundImage)
                    this.showSnackbar({
                        visible: true,
                        text: this.$t('enterprise.successUpdateMessage'),
                        timeout: 6000,
                        style: SnackbarStyle.SUCCESS
                    })
                    this.$emit('commitEnterprise')
                    this.cancel()
                    this.disableSaveBtnFlag = false;
                })
            } else {
                // create
                const enterpriseDto = this.getEnterpriseDto(true)
                // remover imagen del dto
                enterpriseDto.loginBackgroundImage = null
                enterpriseService.create(enterpriseDto).then(async () => {
                    // cuando retorne la promesa, realizar update de unicamente las imágenes
                    enterpriseDto.loginBackgroundImage = this.setBackgroundImage()
                    enterpriseService.saveImage(enterpriseDto.name, enterpriseDto.loginBackgroundImage)
                    this.showSnackbar({
                        visible: true,
                        text: this.$t('enterprise.successCreateMessage'),
                        timeout: 6000,
                        style: SnackbarStyle.SUCCESS
                    })
                    await authService.refreshTokenPayload()
                    this.cancel()
                    this.$emit('commitEnterprise')
                    this.disableSaveBtnFlag = false;
                })
            }

        },
        /**
         * Crea el DTO de la emrpesa para actualizar / guardar
         */
        getEnterpriseDto(create = false) {
            /*
                Config de scoring: como se sacó el requerido, sino se completa nada, entonces el valor seteado es null
                Valido los datos cargados (si hay datos, quiere decir que se cargó una config)
            */
            let scoringConfiguration = null;
            if (this.scoringConfigurationLevelsValidation) {
                scoringConfiguration = {
                    scoringSystem: this.enterpriseDialogScoringTab.model.scoringSystem,
                    additionMaxValue: this.enterpriseDialogScoringTab.model.additionMaxValue,
                    substractionInitialValue: this.enterpriseDialogScoringTab.model.substractionInitialValue,
                    maxSpeedHeavy: this.enterpriseDialogScoringTab.model.maxSpeedHeavy,
                    firstLevel: this.enterpriseDialogScoringTab.model.firstLevel,
                    secondLevel: this.enterpriseDialogScoringTab.model.secondLevel,
                    thirdLevel: this.enterpriseDialogScoringTab.model.thirdLevel
                }
               
                scoringService.processScoringConfigSave(scoringConfiguration);
            }

            const hourString = this.enterpriseDialogDataTab.model.customTimeSpan.start;
            const start = hourString
                ? (moment(hourString, 'HH:mm').utc().hour())
                : moment().startOf('day').utc().hour();

            const enterpriseDto = {
                _id: this.model._id,
                name: this.enterpriseDialogDataTab.model.name ? this.enterpriseDialogDataTab.model.name : null,
                phone: this.enterpriseDialogDataTab.model.phone ? this.enterpriseDialogDataTab.model.phone : null,
                cuit: this.convertCuitStringToNumber(this.enterpriseDialogDataTab.model.cuit),
                email: this.enterpriseDialogDataTab.model.email ? this.enterpriseDialogDataTab.model.email : null,
                fax: this.enterpriseDialogDataTab.model.fax ? this.enterpriseDialogDataTab.model.fax : null,
                customTimeSpan: { 
                    start,
                    enable: this.enterpriseDialogDataTab.model.customTimeSpan.enable,
                    shift: this.enterpriseDialogDataTab.model.customTimeSpan.shift
                },
                suspended: this.enterpriseDialogDataTab.model.suspended,
                address: this.enterpriseDialogAddressTab.model.address ? this.enterpriseDialogAddressTab.model.address : null,
                cityId: this.enterpriseDialogAddressTab.model.cityId ? this.enterpriseDialogAddressTab.model.cityId : null,
                district: this.enterpriseDialogAddressTab.model.district ? this.enterpriseDialogAddressTab.model.district : null,
                provinceId: this.enterpriseDialogAddressTab.model.provinceId ? this.enterpriseDialogAddressTab.model.provinceId : null,
                countryId: this.enterpriseDialogAddressTab.model.countryId ? this.enterpriseDialogAddressTab.model.countryId : null,
                logo: this.enterpriseDialogHeaderTab.model.logo ? this.enterpriseDialogHeaderTab.model.logo : null,
                locales: this.enterpriseDialogHeaderTab.model.locales ? this.enterpriseDialogHeaderTab.model.locales : null,
                menu: this.enterpriseDialogHeaderTab.model.menu ? this.enterpriseDialogHeaderTab.model.menu : null,
                loginLogo: this.enterpriseDialogLoginTab.model.loginLogo ? this.enterpriseDialogLoginTab.model.loginLogo : null,
                loginBackgroundImage: this.enterpriseDialogLoginTab.model.loginBackgroundImage ? this.enterpriseDialogLoginTab.model.loginBackgroundImage : null,
                themes: this.enterpriseDialogThemeTab.model.themes ? this.enterpriseDialogThemeTab.model.themes : null,
                additionalInformation1: this.enterpriseDialogCommentsTab.model.additionalInformation1 ? this.enterpriseDialogCommentsTab.model.additionalInformation1 : null,
                additionalInformation2: this.enterpriseDialogCommentsTab.model.additionalInformation2 ? this.enterpriseDialogCommentsTab.model.additionalInformation2 : null,
                scoringConfiguration,
                events: this.enterpriseDialogEventsTab.model.events,
                ruses: this.enterpriseDialogRusesTab.model.ruses,
                sectors: this.enterpriseDialogSectorsTab.model.sectors,
                legalPersonType: this.enterpriseDialogDataTab.model.legalPersonType,
                timezone: this.enterpriseDialogAddressTab.model.timezone,
                timezoneId: this.enterpriseDialogAddressTab.model.timezoneId,
                harvestStartTime: {
                    start: this.enterpriseDialogHarvestTab.model?.harvestStartTime?.start ?? null,
                    harvests: this.enterpriseDialogHarvestTab.model?.harvestStartTime?.harvests ?? [],
                }
                // users: usersSelected
            }
            if (create) {
                delete enterpriseDto._id
            }
            return enterpriseDto
        },
        /**
         * Convierte el string del cuit en un número
         * @param {*} cuit
         */
        convertCuitStringToNumber(cuit) {
            if (cuit && typeof cuit === 'string') {
                const result = cuit.toString().replaceAll(".", '').replaceAll("/", '').replaceAll("-", '')
                // let result = ''
                // cuitSections.forEach(section => { result += section })
                return Number(result)
            } else if (cuit) {
                return cuit
            } else {
                return null
            }
        },
        /**
         * Agrega guiones a un cuit
         * @param {*} cuit
         */
        convertCuitToStringFormatted(cuit) {
            return `${cuit.toString().substring(0, 2)}-${cuit.toString().substring(2, 10)}-${cuit.toString().substring(10, 11)}`
        },
        /**
         * Setea la imagen de background del login en el dto
         */
        setBackgroundImage() {
            return this.enterpriseDialogLoginTab.model.loginBackgroundImage ? this.enterpriseDialogLoginTab.model.loginBackgroundImage : null
        },
    },
    watch: {
        model: {
            //deep: true,
            immediate: true,
            handler: function (newModel) {
                if (newModel) {
                    // tab 0
                    this.enterpriseDialogDataTab.model.name = newModel.name
                    this.enterpriseDialogDataTab.model.phone = newModel.phone
                    this.enterpriseDialogDataTab.model.cuit = newModel.cuit
                    this.enterpriseDialogDataTab.model.email = newModel.email
                    this.enterpriseDialogDataTab.model.fax = newModel.fax
                    this.enterpriseDialogDataTab.model.customTimeSpan.start = moment.utc(newModel.customTimeSpan.start, 'HH:mm').local().hour()
                    this.enterpriseDialogDataTab.model.customTimeSpan.enable = newModel.customTimeSpan.enable
                    console.log(newModel.customTimeSpan)
                    this.enterpriseDialogDataTab.model.customTimeSpan.shift = newModel.customTimeSpan.shift
                    this.enterpriseDialogDataTab.model.suspended = newModel.suspended
                    this.enterpriseDialogDataTab.model.legalPersonType = newModel.legalPersonType

                    // tab 1
                    this.enterpriseDialogAddressTab.model.address = newModel.address
                    this.enterpriseDialogAddressTab.model.cityId = newModel.cityId
                    this.enterpriseDialogAddressTab.model.district = newModel.district
                    this.enterpriseDialogAddressTab.model.provinceId = newModel.provinceId
                    this.enterpriseDialogAddressTab.model.countryId = newModel.countryId
                    this.enterpriseDialogAddressTab.model.timezone = newModel.timezone
                    this.enterpriseDialogAddressTab.model.timezoneId = newModel.timezoneId

                    // tab 2
                    this.enterpriseDialogHeaderTab.model.logo = newModel.logo
                    this.enterpriseDialogHeaderTab.model.locales = clone(newModel.locales)
                    this.enterpriseDialogHeaderTab.model.menu = clone(newModel.menu)

                    // tab 3
                    this.enterpriseDialogLoginTab.model.loginLogo = newModel.loginLogo
                    this.enterpriseDialogLoginTab.model.loginBackgroundImage = newModel.loginBackgroundImage

                    // tab 4
                    this.enterpriseDialogThemeTab.model.themes = clone(newModel.themes)

                    // tab 5
                    this.enterpriseDialogCommentsTab.model.additionalInformation1 = newModel.additionalInformation1
                    this.enterpriseDialogCommentsTab.model.additionalInformation2 = newModel.additionalInformation2

                    // tab 6
                    this.enterpriseDialogEventsTab.model.events = newModel.events
                    this.enterpriseDialogEventsTab.model.enterpriseId = newModel._id
                    // tab 7
                    this.enterpriseDialogRusesTab.model.ruses = newModel.ruses
                    // tab 8
                    this.enterpriseDialogScoringTab.model.scoringSystem = newModel.scoringConfiguration.scoringSystem
                    this.enterpriseDialogScoringTab.model.additionMaxValue = newModel.scoringConfiguration.additionMaxValue
                    this.enterpriseDialogScoringTab.model.substractionInitialValue = newModel.scoringConfiguration.substractionInitialValue
                    this.enterpriseDialogScoringTab.model.maxSpeedHeavy = newModel.scoringConfiguration.maxSpeedHeavy || DEFAULT_SPEED_VALUE
                    this.enterpriseDialogScoringTab.model.firstLevel = newModel.scoringConfiguration.firstLevel
                    this.enterpriseDialogScoringTab.model.secondLevel = newModel.scoringConfiguration.secondLevel
                    this.enterpriseDialogScoringTab.model.thirdLevel = newModel.scoringConfiguration.thirdLevel

                    // this.enterpriseDialogUsersTab.model.enterpriseId = newModel._id

                    this.enterpriseDialogSectorsTab.model.sectors = newModel.sectors
                    // back-up de la configuración de scoring
                    this.scoringConfigurationBackUp = clone(newModel.scoringConfiguration)

                    // zafras tab
                    this.enterpriseDialogHarvestTab.model.enterpriseTimezone = newModel.timezone
                    this.enterpriseDialogHarvestTab.model.harvestStartTime.start = newModel?.harvestStartTime?.start ?? null
                    this.enterpriseDialogHarvestTab.model.harvestStartTime.harvests = newModel?.harvestStartTime?.harvests ?? []
                }
            }
        }
    }
}
